import * as Sentry from "@sentry/browser";
import { isNetworkFailure } from '../lib/network_failure.js';

const networkFailuresHandledByTurbo = new WeakSet();

document.addEventListener('turbo:fetch-request-error', (event) => {
  const { error } = event.detail;

  if (isNetworkFailure(error)) {
    networkFailuresHandledByTurbo.add(error);
  }
});

Sentry.init({
  dsn: process.env.SENTRY_DSN,
  environment: process.env.SENTRY_ENVIRONMENT || process.env.RAILS_ENV,
  sendDefaultPii: false,
  tracesSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  integrations: [
    Sentry.replayIntegration(),
    Sentry.thirdPartyErrorFilterIntegration({
      // Matches the applicationKey in sentryWebpackPlugin configuration.
      filterKeys: ['c12-frontend'],
      behaviour: 'drop-error-if-exclusively-contains-third-party-frames',
    }),
  ],

  // Capture user context if available
  beforeSend(event, hint) {
    const userId = document.querySelector('meta[name="current-user-id"]')?.content;

    if (networkFailuresHandledByTurbo.has(hint.originalException)) {
      if (!userId) {
        return null;
      }

      event.level = 'warning';
      event.fingerprint = ['turbo-network-failure'];
    }

    if (userId) {
      event.user = {
        id: userId
      };
    }

    return event;
  }
});
